module.exports = __webpack_public_path__ + "img/partners12.dbd0e9cb.png";